import React, { useMemo, useState } from 'react';
import { EVENTS_TOUR_HREF } from 'components/MapPage/eventsTour/eventsTourSteps';
import { REPORTS_TOUR_HREF } from 'components/Reports/reportsTour/reportsTourSteps';
import { INCIDENT_TOUR_HREF } from 'components/IncidentConfig/incidentLifecycleTour/incidentLifecycleTourSteps';
import {
  HWCG_TOUR_HREF,
  hwcgTourNavVisible,
} from 'components/IncidentConfig/hwcgTour/hwcgTourSteps';
import {
  ORG_WORKSPACE_TOUR_HREF,
  orgWorkspaceTourNavVisible,
} from 'components/MapPage/orgWorkspaceTour/orgWorkspaceTourSteps';
import {
  FOC_PLANNING_TOUR_HREF,
  focPlanningTourNavVisible,
} from 'components/MapPage/focPlanningTour/focPlanningTourSteps';
import {
  HUB_COP_TOUR_HREF,
  hubCopTourNavVisible,
} from 'components/MapPage/hubCopTour/hubCopTourSteps';
import {
  SITL_COP_TOUR_HREF,
  sitlCopTourNavVisible,
} from 'components/MapPage/sitlCopTour/sitlCopTourSteps';
import {
  FOC_COP_LAYERS_TOUR_HREF,
  focCopLayersTourNavVisible,
} from 'components/MapPage/focCopLayersTour/focCopLayersTourSteps';
import {
  FOC_FSLTP_TOUR_HREF,
  focFsltpTourNavVisible,
} from 'components/MapPage/focFsltpTour/focFsltpTourSteps';
import {
  FOC_NOTIFICATIONS_TOUR_HREF,
  focNotificationsTourNavVisible,
} from 'components/MapPage/focNotificationsTour/focNotificationsTourSteps';
import {
  FOC_INCIDENTS_TOUR_HREF,
  focIncidentsTourNavVisible,
} from 'components/MapPage/focIncidentsTour/focIncidentsTourSteps';
import {
  FOC_INCIDENT_ROSTER_TOUR_HREF,
  focIncidentRosterTourNavVisible,
} from 'components/MapPage/focIncidentRosterTour/focIncidentRosterTourSteps';
import {
  FOC_INITIAL_RESPONSE_TOUR_HREF,
  focInitialResponseTourNavVisible,
} from 'components/MapPage/focInitialResponseTour/focInitialResponseTourSteps';
import {
  FOC_TRANSITION_TOUR_HREF,
  focTransitionTourNavVisible,
} from 'components/MapPage/focTransitionTour/focTransitionTourSteps';
import {
  FOC_PLANNING_P_COMMAND_STAFF_TOUR_HREF,
  FOC_PLANNING_P_MEETING_TOUR_HREF,
  FOC_PLANNING_P_MODEL_TOUR_HREF,
  FOC_PLANNING_P_PREP_TACTICS_TOUR_HREF,
  FOC_PLANNING_P_TACTICS_MEETING_TOUR_HREF,
  FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_HREF,
  FOC_PLANNING_PREP_TOUR_HREF,
  FOC_IAP_PREP_TOUR_HREF,
  FOC_IAP_FORMS_TOUR_HREF,
} from 'components/MapPage/focPlanningPTour/focPlanningPTourRegistry';
import { focPlanningPTourNavVisible } from 'components/MapPage/focPlanningPTour/focPlanningPTourTypes';
import {
  FOC_WS_TOUR_HREF,
  focWsTourNavVisible,
} from 'components/MapPage/focWsTour/focWsTourSteps';
import {
  FOC_CMD_IC_TOUR_HREF,
  FOC_CMD_LEGAL_TOUR_HREF,
  FOC_CMD_LIAISON_TOUR_HREF,
  FOC_CMD_PIO_TOUR_HREF,
  FOC_CMD_SAFETY_TOUR_HREF,
} from 'components/MapPage/focCmdTour/focCmdTourRegistry';
import { focCmdTourNavVisible } from 'components/MapPage/focCmdTour/focCmdTourSteps';
import {
  FOC_RES_211_TOUR_HREF,
  FOC_RES_213RR_TOUR_HREF,
  FOC_RES_214_TOUR_HREF,
  FOC_RES_MODEL_TOUR_HREF,
} from 'components/MapPage/focResTour/focResTourRegistry';
import { focRes211TourNavVisible } from 'components/MapPage/focResTour/focRes211TourSteps';
import { focRes213rrTourNavVisible } from 'components/MapPage/focResTour/focRes213rrTourSteps';
import { focRes214TourNavVisible } from 'components/MapPage/focResTour/focRes214TourSteps';
import { focResModelTourNavVisible } from 'components/MapPage/focResTour/focResModelTourSteps';
import {
  FOC_PLN_DEMOB_TOUR_HREF,
  FOC_PLN_DOCS_TOUR_HREF,
  FOC_PLN_PSC_TOUR_HREF,
  FOC_PLN_RESOURCE_TOUR_HREF,
  FOC_PLN_SITL_TOUR_HREF,
  focPlnTourNavVisible,
} from 'components/MapPage/focPlnTour/focPlnTourRegistry';
import { FOC_OPS_TOUR_HREF } from 'components/MapPage/focOpsTour/focOpsTourSteps';
import { focOpsTourNavVisible } from 'components/MapPage/focOpsTour/focOpsTourSteps';
import { FOC_LOG_TOUR_HREF } from 'components/MapPage/focLogTour/focLogTourSteps';
import { focLogTourNavVisible } from 'components/MapPage/focLogTour/focLogTourSteps';
import { FOC_DMOB_TOUR_HREF } from 'components/MapPage/focDmobTour/focDmobTourSteps';
import { focDmobTourNavVisible } from 'components/MapPage/focDmobTour/focDmobTourSteps';
import { FOC_EXT_TOUR_HREF } from 'components/MapPage/focExtTour/focExtTourSteps';
import { focExtTourNavVisible } from 'components/MapPage/focExtTour/focExtTourSteps';
import {
  FOC_AI_FOC_TOUR_HREF,
  FOC_AI_IOC_TOUR_HREF,
} from 'components/MapPage/focAiTour/focAiTourRegistry';
import { focAiFocTourNavVisible } from 'components/MapPage/focAiTour/focAiFocTourSteps';
import { focAiIocTourNavVisible } from 'components/MapPage/focAiTour/focAiIocTourSteps';
import {
  FOC_TOUR_LABEL_AI_FOC,
  FOC_TOUR_LABEL_AI_IOC,
  FOC_TOUR_LABEL_CMD_IC,
  FOC_TOUR_LABEL_CMD_LEGAL,
  FOC_TOUR_LABEL_CMD_LIAISON,
  FOC_TOUR_LABEL_CMD_PIO,
  FOC_TOUR_LABEL_CMD_SAFETY,
  FOC_TOUR_LABEL_COP_LAYERS,
  FOC_TOUR_LABEL_DMOB,
  FOC_TOUR_LABEL_EXT,
  FOC_TOUR_LABEL_FSLTP,
  FOC_TOUR_LABEL_HUB_COP,
  FOC_TOUR_LABEL_IAP_FORMS,
  FOC_TOUR_LABEL_IAP_PREP_OPS,
  FOC_TOUR_LABEL_INCIDENT_ROSTER,
  FOC_TOUR_LABEL_INCIDENTS,
  FOC_TOUR_LABEL_INITIAL_RESPONSE,
  FOC_TOUR_LABEL_LOG,
  FOC_TOUR_LABEL_NOTIFICATIONS,
  FOC_TOUR_LABEL_OPS,
  FOC_TOUR_LABEL_ORG_WORKSPACE,
  FOC_TOUR_LABEL_PLANNING,
  FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
  FOC_TOUR_LABEL_PLANNING_P_MEETING,
  FOC_TOUR_LABEL_PLANNING_P_MODEL,
  FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS,
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
  FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW,
  FOC_TOUR_LABEL_PLANNING_PREP_MEETING,
  FOC_TOUR_LABEL_PLN_DEMOB,
  FOC_TOUR_LABEL_PLN_DOCS,
  FOC_TOUR_LABEL_PLN_PSC,
  FOC_TOUR_LABEL_PLN_RESOURCE,
  FOC_TOUR_LABEL_PLN_SITL,
  FOC_TOUR_LABEL_RES_211,
  FOC_TOUR_LABEL_RES_213RR,
  FOC_TOUR_LABEL_RES_214,
  FOC_TOUR_LABEL_RES_MODEL,
  FOC_TOUR_LABEL_SITL_COP,
  FOC_TOUR_LABEL_TRANSITION,
  FOC_TOUR_LABEL_WS,
} from 'components/MapPage/focTourFeedback';
import { openNotesFeedback } from 'components/MapPage/focTourFeedbackBridge';
import {
  useHubOnlyFlag,
  useHwcgFlag,
  useUscgFocRequirementsFlag,
} from 'utils/featureFlags';
import { UPGRADE_TO_ENABLE } from 'components/Notifications/LockedUpgradeOption';
import { Input } from '@/components/ui/input';
import {
  ListGroupNavItem,
  SidebarNavBack,
  SidebarNavSection,
} from './ListGroupNavComponents';
import {
  FOC_FEEDBACK_NOTES_LABEL,
  filterProductTourNavItems,
  type ProductTourNavItem,
} from './productToursNavItems';

const HUB_NOTES_HREF = '/hub?openTab=Notes';

const ProductToursNavPanel: React.FC<{ navBack: () => void }> = ({
  navBack,
}) => {
  const hwcg = useHwcgFlag();
  const hubOnly = useHubOnlyFlag();
  const uscgFocRequirements = useUscgFocRequirementsFlag();
  const [query, setQuery] = useState('');

  const tours = useMemo((): ProductTourNavItem[] => {
    const items: ProductTourNavItem[] = [
      {
        id: 'events',
        label: 'Events',
        to: EVENTS_TOUR_HREF,
        icon: 'event',
      },
      {
        id: 'incident-lifecycle',
        label: 'Incident Lifecycle',
        to: INCIDENT_TOUR_HREF,
        icon: 'electric_bolt',
        lockTooltip: hubOnly ? UPGRADE_TO_ENABLE : undefined,
      },
      {
        id: 'reports',
        label: 'Reports',
        to: REPORTS_TOUR_HREF,
        icon: 'description',
      },
    ];
    if (hwcgTourNavVisible(hwcg)) {
      items.push({
        id: 'hwcg',
        label: 'HWCG Planning & Execution',
        to: HWCG_TOUR_HREF,
        icon: 'water_drop',
        keywords: ['HWCG'],
      });
    }
    if (orgWorkspaceTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-4-1',
        label: FOC_TOUR_LABEL_ORG_WORKSPACE,
        to: ORG_WORKSPACE_TOUR_HREF,
        icon: 'account_tree',
        keywords: ['4.1', 'FOC', 'USCG', 'Organizational Workspace'],
        focFeedbackTourLabel: FOC_TOUR_LABEL_ORG_WORKSPACE,
      });
    }
    if (focPlanningTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-4-3',
        label: FOC_TOUR_LABEL_PLANNING,
        to: FOC_PLANNING_TOUR_HREF,
        icon: 'library_books',
        keywords: ['4.3', 'FOC', 'USCG', 'Planning Repository'],
        focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING,
      });
    }
    if (hubCopTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-5-1-5-2',
        label: FOC_TOUR_LABEL_HUB_COP,
        to: HUB_COP_TOUR_HREF,
        icon: 'map',
        keywords: ['5.1', '5.2', 'FOC', 'COP', 'Hub', 'Map'],
        focFeedbackTourLabel: FOC_TOUR_LABEL_HUB_COP,
      });
    }
    if (sitlCopTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-5-3',
        label: FOC_TOUR_LABEL_SITL_COP,
        to: SITL_COP_TOUR_HREF,
        icon: 'travel_explore',
        keywords: [
          '5.3',
          'FOC',
          'COP',
          'SITL',
          'SitStat',
          'Presentation',
          'Briefing',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_SITL_COP,
      });
    }
    if (focCopLayersTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-5-4-5-5',
        label: FOC_TOUR_LABEL_COP_LAYERS,
        to: FOC_COP_LAYERS_TOUR_HREF,
        icon: 'layers',
        keywords: ['5.4', '5.5', 'FOC', 'COP', 'Layers', 'AOR', 'Hierarchy'],
        focFeedbackTourLabel: FOC_TOUR_LABEL_COP_LAYERS,
      });
    }
    if (focFsltpTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-5-6',
        label: FOC_TOUR_LABEL_FSLTP,
        to: FOC_FSLTP_TOUR_HREF,
        icon: 'public',
        keywords: [
          '5.6',
          'FOC',
          'FSLTP',
          'ArcGIS',
          'Presentation',
          'Briefing',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_FSLTP,
      });
    }
    if (focNotificationsTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-6-1',
        label: FOC_TOUR_LABEL_NOTIFICATIONS,
        to: FOC_NOTIFICATIONS_TOUR_HREF,
        icon: 'notifications',
        keywords: [
          '6.1',
          'FOC',
          'Notifications',
          'US-000',
          'FOC-NOT',
          'SMS',
          'Stand Down',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_NOTIFICATIONS,
      });
    }
    if (focIncidentsTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-7-1',
        label: FOC_TOUR_LABEL_INCIDENTS,
        to: FOC_INCIDENTS_TOUR_HREF,
        icon: 'warning',
        keywords: [
          '7.1',
          'FOC',
          'Incidents',
          'US-I001',
          'FOC-INC',
          'Create Incident',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_INCIDENTS,
      });
    }
    if (focIncidentRosterTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-7-2',
        label: FOC_TOUR_LABEL_INCIDENT_ROSTER,
        to: FOC_INCIDENT_ROSTER_TOUR_HREF,
        icon: 'group',
        keywords: [
          '7.2',
          'FOC',
          'Roster',
          'US-IR001',
          'FOC-INC-006',
          'Incident Roster',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_INCIDENT_ROSTER,
      });
    }
    if (focInitialResponseTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-8-ir',
        label: FOC_TOUR_LABEL_INITIAL_RESPONSE,
        to: FOC_INITIAL_RESPONSE_TOUR_HREF,
        icon: 'description',
        keywords: [
          '8.1',
          '8.2',
          '8.3',
          '8.4',
          'FOC',
          'ICS 201',
          'Initial Response',
          'FOC-IR',
          'US-OA',
          'SITREP',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_INITIAL_RESPONSE,
      });
    }
    if (focTransitionTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-9-1',
        label: FOC_TOUR_LABEL_TRANSITION,
        to: FOC_TRANSITION_TOUR_HREF,
        icon: 'trending_up',
        keywords: [
          '9.1',
          'FOC',
          'Transition',
          'Planning P',
          'Escalate',
          'FOC-TRN',
          'US-ER',
          'ICS 202',
          'ICS 233',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_TRANSITION,
      });
    }
    if (focPlanningPTourNavVisible(uscgFocRequirements)) {
      items.push(
        {
          id: 'foc-10-1',
          label: FOC_TOUR_LABEL_PLANNING_P_MODEL,
          to: FOC_PLANNING_P_MODEL_TOUR_HREF,
          icon: 'account_tree',
          keywords: ['10.1', 'FOC', 'Planning P', 'IMH', 'Operating Model'],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_P_MODEL,
        },
        {
          id: 'foc-10-2',
          label: FOC_TOUR_LABEL_PLANNING_P_MEETING,
          to: FOC_PLANNING_P_MEETING_TOUR_HREF,
          icon: 'event',
          keywords: [
            '10.2',
            'FOC',
            'Planning P',
            'FOC-PP',
            'Meeting',
            'Agenda',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_P_MEETING,
        },
        {
          id: 'foc-10-3',
          label: FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
          to: FOC_PLANNING_P_COMMAND_STAFF_TOUR_HREF,
          icon: 'groups',
          keywords: [
            '10.3',
            'FOC',
            'FOC-PP-004',
            'Command',
            'General Staff',
            'IAP',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_P_COMMAND_STAFF,
        },
        {
          id: 'foc-10-4',
          label: FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS,
          to: FOC_PLANNING_P_PREP_TACTICS_TOUR_HREF,
          icon: 'construction',
          keywords: [
            '10.4',
            'FOC',
            'FOC-PP-006',
            'Prep for Tactics',
            'Organization',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_P_PREP_TACTICS,
        },
        {
          id: 'foc-10-5',
          label: FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW,
          to: FOC_PLANNING_P_TACTICS_WORKFLOW_TOUR_HREF,
          icon: 'grid_on',
          keywords: [
            '10.5',
            'FOC',
            'FOC-PP-009',
            'ICS 234',
            'ICS 215',
            'ICS 215A',
            'US-ER009',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_P_TACTICS_WORKFLOW,
        },
        {
          id: 'foc-10-6',
          label: FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
          to: FOC_PLANNING_P_TACTICS_MEETING_TOUR_HREF,
          icon: 'forum',
          keywords: ['10.6', 'FOC', 'FOC-PP-012', 'Tactics Meeting'],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_P_TACTICS_MEETING,
        },
        {
          id: 'foc-11-1-11-2',
          label: FOC_TOUR_LABEL_PLANNING_PREP_MEETING,
          to: FOC_PLANNING_PREP_TOUR_HREF,
          icon: 'event_note',
          keywords: [
            '11.1',
            '11.2',
            'FOC',
            'FOC-PLAN',
            'Prep for Planning',
            'Planning Meeting',
            'Planning Pulse',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLANNING_PREP_MEETING,
        },
        {
          id: 'foc-12-1-12-3',
          label: FOC_TOUR_LABEL_IAP_PREP_OPS,
          to: FOC_IAP_PREP_TOUR_HREF,
          icon: 'assignment',
          keywords: [
            '12.1',
            '12.2',
            '12.3',
            'FOC',
            'FOC-IAP',
            'IAP',
            'Operations Brief',
            'US-ER',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_IAP_PREP_OPS,
        },
        {
          id: 'foc-12-4',
          label: FOC_TOUR_LABEL_IAP_FORMS,
          to: FOC_IAP_FORMS_TOUR_HREF,
          icon: 'description',
          keywords: [
            '12.4',
            'FOC',
            'FOC-IAP',
            'ICS Forms',
            'Forms dropdown',
            'Approved ICS Forms',
            'Export',
            'Lifecycle',
            'Coverage',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_IAP_FORMS,
        }
      );
    }
    if (focWsTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-13-1',
        label: FOC_TOUR_LABEL_WS,
        to: FOC_WS_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '13.1',
          'FOC',
          'FOC-WS',
          'Position workspace',
          'Role-based',
          'Seat',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_WS,
      });
    }
    if (focCmdTourNavVisible(uscgFocRequirements)) {
      items.push(
        {
          id: 'foc-14-1',
          label: FOC_TOUR_LABEL_CMD_IC,
          to: FOC_CMD_IC_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '14.1',
            'FOC',
            'FOC-CMD',
            'Incident Commander',
            'Unified Command',
            'Command',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_CMD_IC,
        },
        {
          id: 'foc-14-2',
          label: FOC_TOUR_LABEL_CMD_SAFETY,
          to: FOC_CMD_SAFETY_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '14.2',
            'FOC',
            'FOC-CMD',
            'Safety Officer',
            'ICS 208',
            'ICS 215A',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_CMD_SAFETY,
        },
        {
          id: 'foc-14-3',
          label: FOC_TOUR_LABEL_CMD_LIAISON,
          to: FOC_CMD_LIAISON_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '14.3',
            'FOC',
            'FOC-CMD',
            'Liaison Officer',
            'External',
            'Partner',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_CMD_LIAISON,
        },
        {
          id: 'foc-14-4',
          label: FOC_TOUR_LABEL_CMD_PIO,
          to: FOC_CMD_PIO_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '14.4',
            'FOC',
            'FOC-CMD',
            'Public Information Officer',
            'PIO',
            'JIC',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_CMD_PIO,
        },
        {
          id: 'foc-14-5',
          label: FOC_TOUR_LABEL_CMD_LEGAL,
          to: FOC_CMD_LEGAL_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '14.5',
            'FOC',
            'FOC-CMD',
            'Legal Officer',
            'Legal review',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_CMD_LEGAL,
        }
      );
    }
    if (focPlnTourNavVisible(uscgFocRequirements)) {
      items.push(
        {
          id: 'foc-15-1',
          label: FOC_TOUR_LABEL_PLN_PSC,
          to: FOC_PLN_PSC_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '15.1',
            'FOC',
            'FOC-PLN',
            'Planning Section Chief',
            'Planning Pulse',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLN_PSC,
        },
        {
          id: 'foc-15-2',
          label: FOC_TOUR_LABEL_PLN_SITL,
          to: FOC_PLN_SITL_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '15.2',
            'FOC',
            'FOC-PLN',
            'Situation Unit',
            'SITL',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLN_SITL,
        },
        {
          id: 'foc-15-3',
          label: FOC_TOUR_LABEL_PLN_RESOURCE,
          to: FOC_PLN_RESOURCE_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '15.3',
            'FOC',
            'FOC-PLN',
            'Resource Unit',
            'Resources',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLN_RESOURCE,
        },
        {
          id: 'foc-15-4',
          label: FOC_TOUR_LABEL_PLN_DOCS,
          to: FOC_PLN_DOCS_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '15.4',
            'FOC',
            'FOC-PLN',
            'Documentation Unit',
            'ICS 214',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLN_DOCS,
        },
        {
          id: 'foc-15-5',
          label: FOC_TOUR_LABEL_PLN_DEMOB,
          to: FOC_PLN_DEMOB_TOUR_HREF,
          icon: 'badge',
          keywords: [
            '15.5',
            'FOC',
            'FOC-PLN',
            'Demobilization Unit',
            'ICS 221',
          ],
          focFeedbackTourLabel: FOC_TOUR_LABEL_PLN_DEMOB,
        }
      );
    }
    if (focOpsTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-16',
        label: FOC_TOUR_LABEL_OPS,
        to: FOC_OPS_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '16',
          'FOC',
          'FOC-OPS',
          'Operations',
          'ICS 204',
          'Operational O',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_OPS,
      });
    }
    if (focLogTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-17-1',
        label: FOC_TOUR_LABEL_LOG,
        to: FOC_LOG_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '17.1',
          'FOC',
          'FOC-LOG',
          'Logistics',
          'Communications',
          'Medical',
          'Facilities',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_LOG,
      });
    }
    if (focResModelTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-20-1',
        label: FOC_TOUR_LABEL_RES_MODEL,
        to: FOC_RES_MODEL_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '20.1',
          'FOC',
          'FOC-RES',
          'Resource',
          'Assets',
          'T-card',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_RES_MODEL,
      });
    }
    if (focRes213rrTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-20-2',
        label: FOC_TOUR_LABEL_RES_213RR,
        to: FOC_RES_213RR_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '20.2',
          'FOC',
          'FOC-RES',
          '213RR',
          'Resource Requests',
          'Asset Requests',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_RES_213RR,
      });
    }
    if (focRes211TourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-20-3',
        label: FOC_TOUR_LABEL_RES_211,
        to: FOC_RES_211_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '20.3',
          'FOC',
          'FOC-RES',
          'ICS 211',
          'Check-In',
          'Check-Out',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_RES_211,
      });
    }
    if (focRes214TourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-20-4',
        label: FOC_TOUR_LABEL_RES_214,
        to: FOC_RES_214_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '20.4',
          'FOC',
          'FOC-RES',
          'ICS 214',
          'Activity Log',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_RES_214,
      });
    }
    if (focDmobTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-21',
        label: FOC_TOUR_LABEL_DMOB,
        to: FOC_DMOB_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '21',
          'FOC',
          'FOC-DMOB',
          'Demobilization',
          'ICS 221',
          'ICS 225',
          'ICS 236',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_DMOB,
      });
    }
    if (focExtTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-22',
        label: FOC_TOUR_LABEL_EXT,
        to: FOC_EXT_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '22',
          'FOC',
          'FOC-EXT',
          'External',
          'Partner',
          'Collaboration',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_EXT,
      });
    }
    if (focAiIocTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-23-1',
        label: FOC_TOUR_LABEL_AI_IOC,
        to: FOC_AI_IOC_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '23.1',
          'FOC',
          'US-AI',
          'PRATUS AI',
          'SITREP',
          'IOC',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_AI_IOC,
      });
    }
    if (focAiFocTourNavVisible(uscgFocRequirements)) {
      items.push({
        id: 'foc-23-2',
        label: FOC_TOUR_LABEL_AI_FOC,
        to: FOC_AI_FOC_TOUR_HREF,
        icon: 'badge',
        keywords: [
          '23.2',
          'FOC',
          'FOC-AI',
          'PRATUS AI',
          'Audit',
          'Corpus',
        ],
        focFeedbackTourLabel: FOC_TOUR_LABEL_AI_FOC,
      });
    }
    return items;
  }, [hwcg, hubOnly, uscgFocRequirements]);

  const visibleTours = useMemo(
    () => filterProductTourNavItems(tours, query),
    [tours, query]
  );

  return (
    <nav
      aria-label="secondary sidebar"
      className="second-panel tw:flex tw:flex-col tw:gap-1"
    >
      <SidebarNavBack title="Product Tours" onBack={navBack} />
      <div className="tw:px-3 tw:pb-1">
        <Input
          type="search"
          value={query}
          onChange={(event) => setQuery(event.target.value)}
          placeholder="Search product tours…"
          aria-label="Search product tours"
          className="tw:h-8"
        />
      </div>
      <SidebarNavSection title="Product Tours">
        {visibleTours.length === 0 ? (
          <p className="tw:px-3 tw:py-2 tw:text-xs tw:text-muted-foreground">
            No matching tours
          </p>
        ) : null}
        {visibleTours.map((tour) => (
          <React.Fragment key={tour.id}>
            <ListGroupNavItem
              to={tour.to}
              icon={tour.icon}
              label={tour.label}
              lockTooltip={tour.lockTooltip}
            />
            {tour.focFeedbackTourLabel ? (
              <ListGroupNavItem
                to={HUB_NOTES_HREF}
                label={FOC_FEEDBACK_NOTES_LABEL}
                secondary
                onClick={() => {
                  void openNotesFeedback(tour.focFeedbackTourLabel!);
                }}
              />
            ) : null}
          </React.Fragment>
        ))}
      </SidebarNavSection>
    </nav>
  );
};

export default ProductToursNavPanel;
